import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";
import SurveyImgVideo from "../Asset/Video/LoginPages.mp4";
import Header from "./Header";
import HeroVideo from "../Asset/Video/Truvey-Hero-Animation.mp4";
import { Link } from "react-router-dom";
import UpperFooter from "./UpperFooter";
import {
  Palette,
  Send,
  FileBarChart2,
  BarChart3,
  ChevronRight,
  Users,
  Smile,
  PieChart,
  CheckSquare,
} from "lucide-react";
import AboutModal from "./AboutUsModal/AboutModal";
import useCaseImage from "../Asset/Images/Usecase.jpg";
import Contact from "../Asset/Images/Contact.png";

const Home = () => {
  const [showAbout, setShowAbout] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("JWTToken"); // Retrieve token from localStorage
    if (token) {
      navigate("/SurveyList"); // Redirect if token exists
    }
  }, [navigate]);
  return (
    <>
      <Header />
      <div className="bg-white">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="overlay"></div>

          <div className="hero-box">
            {/* TOP TEXT */}
            <div className="hero-text">
              <h1 className="hero-title">
                <span className="highlight">XPSURVEY</span> – FAST, FLEXIBLE,
                AND INSIGHTFUL
              </h1>

              <p className="hero-subtitle">
                Create Free, Customizable Surveys With Unlimited <br />
                Questions And Reports Delivered In Excel.
              </p>
            </div>

            {/* BOTTOM BUTTON */}
            <div className="hero-btn-container">
              <Link to="/SignUp" className="hero-btn">
                Create Survey →
              </Link>
            </div>
          </div>
        </div>

        {/* About section */}

        <div className="about-section-wrapper">
          {/* TOP CONTENT */}
          <div className="about-top text-center">
            <h2 className="about-title">About XPSurvey</h2>

            <p className="about-desc">
              XP in XPSurvey stands for Express & eXpress yourself. <br />
              We make surveys fast, easy, and flexible - for admins, designers,
              and respondents.
            </p>

            <p className="about-desc mt-3">
              Developed by an experienced team from HR, IT, Finance, Marketing &
              Sales, XPSurvey was designed to capture and gauge client,
              employee, customer, or partner feedback while keeping
              administrative convenience in mind.
            </p>

            <button className="about-btn" onClick={() => setShowAbout(true)}>
              More About Us
            </button>
          </div>

          {/* FEATURES */}
          <div className="about-features container">
            <div className="row justify-content-center">
              <div className="col-md-3 col-6 mb-4">
                <div className="feature-card">
                  <div className="icon-wrapper">
                    <div className="icon red">
                      <Palette size={20} />
                    </div>
                  </div>
                  <p>
                    Design personalized surveys with various question types.
                  </p>
                </div>
              </div>

              <div className="col-md-3 col-6 mb-4">
                <div className="feature-card">
                  <div className="icon-wrapper">
                    <div className="icon blue">
                      <Send size={22} />
                    </div>
                  </div>
                  <p>
                    Generate unique survey links for easy distribution via
                    email, social media, or email.
                  </p>
                </div>
              </div>

              <div className="col-md-3 col-6 mb-4">
                <div className="feature-card">
                  <div className="icon-wrapper">
                    <div className="icon orange">
                      <FileBarChart2 size={22} />
                    </div>
                  </div>
                  <p>
                    Get comprehensive reports in Excel format for further
                    analysis and customization.
                  </p>
                </div>
              </div>

              <div className="col-md-3 col-6 mb-4">
                <div className="feature-card">
                  <div className="icon-wrapper">
                    <div className="icon green">
                      <BarChart3 size={22} />
                    </div>
                  </div>
                  <p>
                    No restrictions on the number of questions or responses.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why to choose Section */}
        <div className="why-section">
          <h2 className="why-title">Why Choose XPSurvey</h2>
          <p className="why-subtitle">
            Delivering fast, flexible, and secure survey solutions for smarter
            decisions.
          </p>

          <div className="why-grid">
            <div className="why-card">
              <h4>Easy Survey Design</h4>
              <p>
                Create surveys quickly with a simple and intuitive interface no
                technical expertise required.
              </p>
            </div>

            <div className="why-card">
              <h4>User-Friendly Experience</h4>
              <p>
                Designed for designers, administrators, and respondents to
                ensure smooth usage for all.
              </p>
            </div>

            <div className="why-card">
              <h4>Administrative Ease</h4>
              <p>
                Manage surveys effortlessly with scheduling, follow-ups, and
                customized content options.
              </p>
            </div>

            <div className="why-card">
              <h4>Data Confidentiality</h4>
              <p>
                Ensure respondent anonymity and build trust with secure data
                handling.
              </p>
            </div>

            <div className="why-card">
              <h4>Customizable Reports</h4>
              <p>
                Generate reports tailored to your needs for clear and actionable
                insights.
              </p>
            </div>

            <div className="why-card">
              <h4>Real-Time Voting & Polling</h4>
              <p>
                Enable instant voting and polling with live results for faster
                decision-making.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="faq-section">
          <h2 className="faq-title">Frequently Asked Questions (FAQs)</h2>

          <div className="accordion" id="faqAccordion">
            {/* ITEM */}
            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q1"
              >
                <ChevronRight className="arrow" size={18} />
                What is XPSurvey Platform?
              </button>

              <div id="q1" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>XPSurvey Platform</strong> is a user-friendly survey
                  creation tool that allows you to create free, customizable
                  surveys with unlimited questions and generate reports
                  delivered in Excel format.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q2"
              >
                <ChevronRight className="arrow" size={18} />
                How can I create surveys with XPSurvey Platform?
              </button>
              <div id="q2" className="accordion-collapse collapse">
                <div className="faq-answer">
                  You can easily create surveys by signing up on our website,
                  designing personalized surveys with various question types,
                  and sharing unique survey links for easy distribution. With
                  customized thumbnail.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q3"
              >
                <ChevronRight className="arrow" size={18} />
                What is Multiple Choice ?
              </button>
              <div id="q3" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Multiple-choice questions </strong>are fundamental
                  survey questions that provide respondents to select one option
                  from multiple options available (Ideal for collecting
                  preferences or specific information).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q4"
              >
                <ChevronRight className="arrow" size={18} />
                What are Check Boxes ?
              </button>
              <div id="q4" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Check boxes</strong> also known as multi-select
                  questions offers respondents to pick more than one answer
                  alternatives (Useful for gathering broader opinions or
                  preferences).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q5"
              >
                <ChevronRight className="arrow" size={18} />
                What is Short Answer ?
              </button>
              <div id="q5" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Text box</strong> Prompt respondents to provide
                  concise answers to your question in a single line (Good for
                  gathering quick feedback or specific details).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q6"
              >
                <ChevronRight className="arrow" size={18} />
                What is Paragraph ?
              </button>
              <div id="q6" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Paragraph</strong> allows respondents for more
                  detailed and in-depth written responses/answers. (Suitable for
                  gathering explanations or open-ended feedback)
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q7"
              >
                <ChevronRight className="arrow" size={18} />
                What is Rating Bar ?
              </button>
              <div id="q7" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Rating Bar</strong> present a scale for respondents to
                  choose a rating or score based on their opinion (Great for
                  gauging satisfaction levels or preferences on a spectrum).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q8"
              >
                <ChevronRight className="arrow" size={18} />
                What is answertype Mobile number ?
              </button>
              <div id="q8" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Mobile Number</strong> allow respondents to input
                  their mobile phone number directly (Useful for further
                  communication or verification).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q9"
              >
                <ChevronRight className="arrow" size={18} />
                What is Answer in number ?
              </button>
              <div id="q9" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Answer in number</strong> ask for a numerical response
                  from participants. (Ideal for collecting quantitative data or
                  values).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q10"
              >
                <ChevronRight className="arrow" size={18} />
                What is answertype Email ?
              </button>
              <div id="q10" className="accordion-collapse collapse">
                <div className="faq-answer">
                  {" "}
                  Collect <strong>email</strong> addresses from participants for
                  further communication or follow-up. (Handy for building an
                  email list or sending additional information).
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <button
                className="faq-question"
                data-bs-toggle="collapse"
                data-bs-target="#q11"
              >
                <ChevronRight className="arrow" size={18} />
                What is answertype Date ?
              </button>
              <div id="q11" className="accordion-collapse collapse">
                <div className="faq-answer">
                  <strong>Date</strong> Provide respondents with a calendar tool
                  to select a specific date (Useful for collecting information
                  about events or deadlines).
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Use-case Section */}
        <div className="usecase-section">
          {/* TOP WHITE SECTION */}
          <div className="usecase-top">
            <div className="usecase-image">
              <img src={useCaseImage} alt="survey" />
            </div>

            <div className="usecase-text">
              <p>
                XPSurvey is perfect for organizations looking to understand and
                engage their people. Use it for employee engagement and
                feedback, track customer satisfaction, conduct market research
                and opinion polls, or organize events, voting, and
                decision-making processes. With XPSurvey, collecting insights
                becomes fast, simple, and actionable.
              </p>
            </div>
          </div>

          {/* 🔥 GREEN SECTION */}
          <div className="usecase-green">
            {/* CARDS */}
            <div className="usecase-cards">
              <div className="usecase-card purple">
                <Users size={32} />
                <p>Employee engagement & feedback</p>
              </div>

              <div className="usecase-card blue">
                <Smile size={32} />
                <p>Customer satisfaction surveys</p>
              </div>

              <div className="usecase-card green">
                <PieChart size={32} />
                <p>Market research & opinion polls</p>
              </div>

              <div className="usecase-card orange">
                <CheckSquare size={32} />
                <p>Events, voting & decision making</p>
              </div>
            </div>

            {/* BOTTOM TEXT */}
            <div className="usecase-bottom">
              <p>
                XPSurvey is highly customizable to your needs, all while being
                cost-effective. Tailor surveys, reports, and polls exactly how
                you want without compromising speed or convenience.
              </p>
            </div>
          </div>
        </div>

        {/* Get start Section */}
        <div className="ready-section">
          <h2>Ready To Get Started?</h2>

          <p>
            Visit our website today and experience the power of free,
            customizable surveys!
          </p>
          <Link className="ready-btn" to="/SignUp">
            GET STARTED
          </Link>
        </div>

        {/* Contact Section */}
        <div className="contact-section">
          <div className="contact-container">
            {/* LEFT FORM */}
            <div className="contact-form-card">
              <form className="contact-form">
                <label>Name</label>
                <input type="text" placeholder="" />

                <label>Email Address</label>
                <input type="email" placeholder="" />

                <label>Phone Number</label>
                <input type="text" placeholder="" />

                <label>Your Message</label>
                <textarea rows="4"></textarea>

                <button type="submit" className="contact-btn">
                  Submit
                </button>
              </form>
            </div>

            {/* RIGHT IMAGE */}
            <div className="contact-image">
              <img src={Contact} alt="contact" />
            </div>
          </div>
        </div>
      </div>
      <UpperFooter />

      <AboutModal show={showAbout} onClose={() => setShowAbout(false)} />
    </>
  );
};
export default Home;
